<template>
    <div class="appGrey" style="min-height: 100%">
        {{ computedInit }}

        <!--Personal Details-->
        <div :class="$vuetify.breakpoint.width < 800 ? 'd-flex flex-column' : 'd-flex align-center'">
            <!--Profile Picture-->
            <div
                class="appWhite d-flex flex-column rounded-lg mr-4 pa-2"
                :style="$vuetify.breakpoint.width < 800 ? 'height: 272px; width: 100%' : 'aspect-ratio: 1/1; height: 272px; width: 272px'"
            >
                <!--Temporary Profile Picture-->
                <v-img
                    v-if="tempProfilePicture"
                    :src="tempProfilePicture"
                    class="rounded-lg"
                    max-height="272"
                    :style="$vuetify.breakpoint.width < 800 ? 'height: 256px' : 'aspect-ratio: 1/1; height: 256px; width: 256px'"
                />

                <!--Profile Picture-->
                <v-img
                    v-if="!tempProfilePicture && form.userProfilePicture"
                    :src="MIX_getImagePath('profilePictures', fullUserData.fileData.fileName, fullUserData.fileData.fileToken)"
                    class="rounded-lg"
                    max-height="272"
                    :style="$vuetify.breakpoint.width < 800 ? 'height: 256px' : 'aspect-ratio: 1/1; height: 256px; width: 256px'"
                />

                <!--Default Profile Picture-->
                <app-icon v-if="!form.userProfilePicture" cover class="d-flex align-self-center" icon="user" size="256" />

                <!--Image Upload button-->
                <image-upload
                    v-if="!isReadOnly"
                    @emitImageUpload="emittedImageUpload"
                    folder="profilePictures"
                    :id-for-image="form.entityId"
                    image-for="profilePicture"
                    style="position: absolute"
                />
            </div>

            <!--Personal Details-->
            <div style="width: 100%">
                <!--UserName-->
                <app-form-field
                    form-type="textInput"
                    :class="$vuetify.breakpoint.width < 800 ? 'mt-4' : ''"
                    :disabled="isReadOnly"
                    :error="errors.userName"
                    :error-message="errors.userNameErrorMessage"
                    label="Full Name"
                    v-model.trim="form.userName"
                />

                <!--Position-->
                <app-form-field
                    form-type="textInput"
                    class="mt-4"
                    :disabled="isReadOnly"
                    :error="errors.userPosition"
                    :error-message="errors.userPositionErrorMessage"
                    label="Position"
                    v-model.trim="form.userPosition"
                />

                <!--Email-->
                <app-form-field
                    form-type="textInput"
                    class="mt-4"
                    :disabled="true"
                    :error="errors.userEmail"
                    :error-message="errors.userEmailErrorMessage"
                    label="Email"
                    title="Email addresses cannot be changed at present."
                    v-model.trim="form.userEmail"
                />

                <!--Telephone-->
                <app-form-field
                    form-type="textInput"
                    class="mt-4"
                    :disabled="isReadOnly"
                    :error="errors.userTelephone"
                    :error-message="errors.userTelephoneErrorMessage"
                    label="Telephone"
                    v-model.trim="form.userTelephone"
                />
            </div>
        </div>

        <!--Employment-->
        <div v-if="form.userType === 'Staff'">
            <form-section-title class="mt-4" title="Employment" />
            <v-row no-gutters>
                <!--ID Number-->
                <v-col :class="$vuetify.breakpoint.width < 600 ? '' : 'pr-2'" :cols="$vuetify.breakpoint.width < 600 ? 12 : 6">
                    <app-form-field
                        form-type="textInput"
                        :disabled="isReadOnly"
                        label="ID Number (optional)"
                        v-model.trim="form.userInternalIdNumber"
                    />
                </v-col>

                <!--Pay Grade-->
                <v-col :class="$vuetify.breakpoint.width < 600 ? 'mt-4' : 'pl-2'" :cols="$vuetify.breakpoint.width < 600 ? 12 : 6">
                    <app-form-field
                        form-type="select"
                        :disabled="MIX_getCurrentUser().userLevel !== 'Staff-Admin' || isReadOnly"
                        :error="errors.userPayGrade"
                        :error-message="errors.userPayGradeErrorMessage"
                        :items="userPayGradeOptions"
                        label="Pay Grade"
                        v-model="form.userPayGrade"
                    />
                </v-col>
            </v-row>
        </div>

        <!--Media Personnel-->
        <div v-if="form.userType === 'Organisation'">
            <form-section-title class="mt-4" title="Media Personnel" />
            <v-row no-gutters>
                <!--Outlet/Publication-->
                <v-col :class="$vuetify.breakpoint.width < 600 ? '' : ''" :cols="$vuetify.breakpoint.width < 600 ? 12 : 12">
                    <app-form-field
                        form-type="textInput"
                        :disabled="isReadOnly"
                        :error="errors.userOutletPublication"
                        :error-message="errors.userOutletPublicationErrorMessage"
                        label="Outlet/Publication"
                        v-model.trim="form.userOutletPublication"
                    />
                </v-col>

                <!--Press Type-->
                <v-col :class="$vuetify.breakpoint.width < 600 ? 'mt-4' : 'mt-4 pr-2'" :cols="$vuetify.breakpoint.width < 600 ? 12 : 6">
                    <app-form-field
                        form-type="autoComplete"
                        :disabled="isReadOnly"
                        :error="errors.userPressType"
                        :error-message="errors.userPressTypeErrorMessage"
                        :items="userPressTypeOptions"
                        label="Press Type"
                        v-model.trim="form.userPressType"
                    />
                </v-col>
            </v-row>
        </div>

        <!--Access & Abilities | Observation Responsibilities | Configuration-->
        <!--Only for Admin-->
        <div v-if="MIX_getCurrentUser().userLevel === 'Staff-Admin'">
            <!--Access & Abilities | Observation Responsibilities-->
            <!--<form-section-title class="mt-4" title="Access & Abilities, and Observation Responsibilities"/>-->
            <!--<v-row no-gutters>-->

            <!--	&lt;!&ndash;Access & Abilities&ndash;&gt;-->
            <!--	<v-col :class="$vuetify.breakpoint.width < 600 ? '' : 'pr-2'"-->
            <!--		   :cols="$vuetify.breakpoint.width < 600 ? 12 : 6">-->
            <!--		<app-form-field form-type="autoComplete"-->
            <!--						:disabled="isReadOnly"-->
            <!--						label="Access & Abilities"-->
            <!--						v-model="form.userAccessAndAbilities"/>-->
            <!--	</v-col>-->

            <!--	&lt;!&ndash;Observation Responsibilities&ndash;&gt;-->
            <!--	<v-col :class="$vuetify.breakpoint.width < 600 ? 'mt-4' : 'pl-2'"-->
            <!--		   :cols="$vuetify.breakpoint.width < 600 ? 12 : 6">-->
            <!--		<app-form-field form-type="autoComplete"-->
            <!--						:disabled="isReadOnly"-->
            <!--						label="Observation Responsibilities"-->
            <!--						v-model="form.userObservationResponsibilities"/>-->
            <!--	</v-col>-->

            <!--</v-row>-->

            <!--Configuration-->
            <form-section-title class="mt-4" title="Configuration" />
            <v-row no-gutters>
                <!--User Type-->
                <v-col :class="$vuetify.breakpoint.width < 600 ? '' : 'pr-2'" :cols="$vuetify.breakpoint.width < 600 ? 12 : 4">
                    <app-form-field
                        form-type="autoComplete"
                        :disabled="isReadOnly"
                        :error="errors.userType"
                        :error-message="errors.userTypeErrorMessage"
                        :items="userTypeOptions"
                        label="User Type"
                        v-model="form.userType"
                    />
                </v-col>

                <!--User Role-->
                <v-col :class="$vuetify.breakpoint.width < 600 ? 'mt-4' : 'px-2'" :cols="$vuetify.breakpoint.width < 600 ? 12 : 4">
                    <app-form-field
                        form-type="autoComplete"
                        :disabled="isReadOnly"
                        :error="errors.userRole"
                        :error-message="errors.userRoleErrorMessage"
                        :items="computedUserRoleOptions"
                        label="User Role"
                        v-model="form.userRole"
                    />
                </v-col>

                <!--User Status-->
                <v-col :class="$vuetify.breakpoint.width < 600 ? 'mt-4' : 'pl-2'" :cols="$vuetify.breakpoint.width < 600 ? 12 : 4">
                    <app-form-field
                        form-type="autoComplete"
                        :disabled="isReadOnly"
                        :error="errors.userStatus"
                        :error-message="errors.userStatusErrorMessage"
                        label="User Status"
                        :items="userStatusOptions"
                        v-model="form.userStatus"
                    />
                </v-col>

                <!--Organisation-->
                <v-col :class="$vuetify.breakpoint.width < 600 ? 'mt-4' : 'mt-4 pr-2'" :cols="$vuetify.breakpoint.width < 600 ? 12 : 12">
                    <app-form-field
                        form-type="autoComplete"
                        :disabled="isReadOnly"
                        label="Organisation"
                        :items="organisationsData"
                        item-text="organisationName"
                        :return-object="true"
                        v-model="displayOrganisation"
                    />
                    <app-text v-if="!displayOrganisation?.entityId && isOrganisationDeleted" class="mt-2 ml-2" color="red">
                        <b>Organisation has been deleted</b>
                    </app-text>
                    <app-text v-else-if="!displayOrganisation?.entityId" class="mt-2 ml-2" color="grey9">
                        Registering as: <b>{{ form.userOrganisation[0] }}</b>
                    </app-text>
                </v-col>
            </v-row>
        </div>

        <!--Save Button-->
        <div class="d-flex justify-end mt-4">
            <app-btn
                v-if="!isReadOnly"
                @click.native="handleSaveItem"
                color="green"
                icon="save"
                icon-color="white"
                label="Save"
                label-color="white"
            />
        </div>

        <!--Dialogs -------------------------------- -->
        <app-dialog v-if="isOrganisationDialogVisible" is-visible="isOrganisationDialogVisible">
            <div class="appGrey rounded-lg pa-4">
                <div class="d-flex align-center">
                    <app-icon class="mr-4" color="orange" icon="error" size="48" />
                    <app-text size="medium-bold">Organisation Management</app-text>
                </div>

                <v-divider class="my-4" />

                <app-text v-if="isOrganisationDeleted">
                    This user's organisation has been deleted and they need to be assigned to a new organisation.
                    <br />
                    <br />
                    Please select an existing organisation from the Organisation dropdown in the form and approve the user to assign them to that organisation.
                </app-text>

                <app-text v-else>
                    This user has registered with <b>{{ form.userOrganisation[0] }}</b> as their organisation.
                    <br />
                    <br />
                    <b>New Organisations</b>
                    <br />
                    If this is a new organisation that cannot be found in the list of organisations, approve the user and save the form, and a new
                    organisation will be created with this user set as the primary contact so they can manage their own staff.
                    <br />
                    <br />
                    <b>Existing Organisations</b>
                    <br />
                    If this is an existing organisation, please reject the user and ask them to refer to their existing organisation manager who can
                    manage their own staff.
                </app-text>

                <v-divider v-if="!isOrganisationDeleted" class="my-4" />

                <div v-if="!isOrganisationDeleted">
                    <!--Exact matches-->
                    <app-text size="normal-bold">Exact matches</app-text>
                    <app-text v-if="!getPossibleOrganisationMatches().exactMatches?.length" class="ml-2" color="grey9">
                        There are no exact matches
                    </app-text>
                    <app-text v-for="item in getPossibleOrganisationMatches().exactMatches" :key="item.entityId">
                        - {{ item.organisationName }}
                    </app-text>

                    <!--Partial matches-->
                    <app-text class="mt-4" size="normal-bold">Partial matches</app-text>
                    <app-text v-if="!getPossibleOrganisationMatches().partialMatches?.length" class="ml-2" color="grey9">
                        There are no partial matches
                    </app-text>
                    <app-text v-for="item in getPossibleOrganisationMatches().partialMatches" :key="item.entityId">
                        - {{ item.organisationName }}
                    </app-text>
                </div>

                <v-divider class="mt-4" />

                <!--Action Buttons-->
                <div class="mt-4">
                    <app-btn @click.native="isOrganisationDialogVisible = false" :block="true" label="Close" />
                </div>
            </div>
        </app-dialog>
    </div>
</template>

<script>
export default {
    name: 'UserForm',

    props: ['fullUserData', 'isReadOnly', 'organisationsData'],

    data: () => ({
        displayOrganisation: {},
        errors: {
            userEmail: false,
            userEmailErrorMessage: '',
            userInternalIdNumber: false,
            userInternalIdNumberErrorMessage: '',
            userName: false,
            userNameErrorMessage: '',
            userOutletPublication: false,
            userOutletPublicationErrorMessage: '',
            userPayGrade: false,
            userPayGradeErrorMessage: '',
            userPosition: false,
            userPositionErrorMessage: '',
            userPressType: false,
            userPressTypeErrorMessage: '',
            userRole: false,
            userRoleErrorMessage: '',
            userTelephone: false,
            userTelephoneErrorMessage: '',
            userType: false,
            userTypeErrorMessage: ''
        },
        // User form copied into Organisations - be aware of changes
        form: {
            entityId: '',
            userAcceptedPrivacyPolicy: null,
            userAccessAndAbilities: [],
            userDefaultZones: '',
            userEmail: '',
            userFbId: '',
            userInternalIdNumber: '',
            userLastSwappDateTime: 0,
            userLastSwappLocationId: '',
            userLastSwappMethod: '',
            userLastSwappSiteId: '',
            userLevel: '',
            userName: '',
            userObservationResponsibilities: [],
            userOutletPublication: '',
            userOrganisation: '',
            userPayGrade: '',
            userPosition: '',
            userPressType: '',
            userProfilePicture: '',
            userRole: '',
            userStatus: '',
            userSwappStatus: '',
            userTeams: [],
            userTelephone: '',
            userType: '',

            createdUserId: '',
            createdDateTime: 0,
            createdUserName: '',
            modifiedUserId: '',
            modifiedDateTime: 0,
            modifiedUserName: '',
            isDeleted: false,
            deletedUserId: '',
            deletedDateTime: 0,
            deletedUserName: ''
        },
        organisationForm: {
            entityId: '',
            organisationName: '',
            organisationStatus: 'Active',
            organisationManagers: [],
            organisationDefaultZones: [
                { zone: 'Zone 1', hasAccess: false },
                { zone: 'Zone 2', hasAccess: false },
                { zone: 'Zone 3', hasAccess: false },
                { zone: 'Zone 4', hasAccess: false },
                { zone: 'Zone 5', hasAccess: false }
            ],
            isMedia: true,

            createdUserId: '',
            createdUserName: '',
            createdDateTime: 0,
            modifiedUserId: '',
            modifiedUserName: '',
            modifiedDateTime: 0,
            isDeleted: false,
            deletedUserId: '',
            deletedUserName: '',
            deletedDateTime: 0
        },
        imageFolderName: 'profilePictures',
        isOrganisationDialogVisible: false,
        tempProfilePicture: ''
    }),

    computed: {
        /**
         * Computed Init
         *
         * If there is any form data, assign it to the form.
         * If there is no form data, it will be blank (new).
         */
        computedInit() {
            const t = this
            const FORM_DATA = t.$props.fullUserData.userData

            if (FORM_DATA?.entityId) {
                t.form = FORM_DATA

                // Ensure userOrganisation is always an array
                if (!Array.isArray(t.form.userOrganisation)) {
                    t.form.userOrganisation = t.form.userOrganisation ? [t.form.userOrganisation] : []
                }

                // Find organization in data
                if (Array.isArray(t.organisationsData) && t.form.userOrganisation.length > 0) {
                    t.displayOrganisation = t.organisationsData.find((org) => org.entityId === t.form.userOrganisation[0]) || null
                }

                // Only show dialog for pending users who registered with a NEW organisation (not an existing one)
                if (t.form.userStatus === 'Pending' && !t.displayOrganisation?.entityId) {
                    t.isOrganisationDialogVisible = true
                }
            }
        },

        /**
         * Is Organisation Deleted
         *
         * Check if the user's organisation ID looks like a system-generated ID (meaning it's a deleted org ID)
         * rather than a string name (meaning it's a new org registration)
         */
        isOrganisationDeleted() {
            const t = this
            const orgValue = Array.isArray(t.form.userOrganisation) ? t.form.userOrganisation[0] : t.form.userOrganisation

            // Check if it looks like a ULID/system ID (26 uppercase alphanumeric characters)
            // or a UUID pattern (8-4-4-4-12 hexadecimal characters)
            const ULID_PATTERN = /^[0-9A-Z]{26}$/
            const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

            return orgValue && (ULID_PATTERN.test(orgValue) || UUID_PATTERN.test(orgValue))
        },

        /**
         * Computed User Role Options
         *
         * Return the correct roles for the change user type.
         * If the user type has changed, clear the role.
         */
        computedUserRoleOptions() {
            const t = this
            const USER_TYPE = t.form.userType
            let userRoles = []

            // Staff
            if (USER_TYPE === 'Staff') {
                userRoles = ['Admin', 'Manager', 'Supervisor', 'User']

                if (!userRoles.includes(t.form.userRole)) t.form.userRole = ''
            }

            // Steward
            if (USER_TYPE === 'Steward') {
                userRoles = ['Supervisor', 'Deputy', 'User']

                if (!userRoles.includes(t.form.userRole)) t.form.userRole = ''
            }

            // Organisation
            if (USER_TYPE === 'Organisation') {
                userRoles = ['Manager', 'User']

                if (!userRoles.includes(t.form.userRole)) t.form.userRole = ''
            }

            // Media
            if (USER_TYPE === 'Media') {
                userRoles = ['User']

                if (!userRoles.includes(t.form.userRole)) t.form.userRole = ''
            }

            return userRoles
        }
    },

    methods: {
        /**
         * Clear Errors
         *
         * Clear all errors and their messages.
         */
        clearErrors() {
            const t = this

            for (const error in t.errors) {
                if (typeof t.errors[error] === 'string') t.errors[error] = ''
                if (typeof t.errors[error] === 'boolean') t.errors[error] = false
            }
        },

        /**
         * Completely Destroy User
         *
         * If the user is rejected, completely remove them from the system.
         * This will remove the user data, and the Firebase account.
         */
        async completelyDestroyUser() {
            const t = this

            // Delete the user from the DB
            const RESPONSE = await t.MIX_redis_completelyDestroyUser(t.form.entityId)

            // Handle any errors
            if (RESPONSE.hasErrors) {
                console.error('Error completely destroying User: ', RESPONSE.error)
                t.$sharedState.errorMessage = 'There was a problem deleting this User, please try again.'
                return
            }

            t.$sharedState.successMessage = 'Deleted User'
            t.$emit('emitReloadPage')
        },

        /**
         * Create Item
         *
         * Create the form and save to the DB.
         */
        async createItem() {
            const t = this

            const RESPONSE = await t.MIX_redis_create('user', t.form)

            // Handle any errors
            if (RESPONSE.hasErrors) {
                console.error('Error creating User: ', RESPONSE.error)
                t.$sharedState.errorMessage = 'There was a problem creating this User, please try again.'
                return
            }

            t.$sharedState.successMessage = 'Created User'
            t.$emit('emitReloadPage')
        },

        /**
         * Create Organisation
         *
         * Create the organisation and save to the DB.
         */
        async createOrganisation() {
            const t = this
            const orgName = Array.isArray(t.form.userOrganisation) ? t.form.userOrganisation[0] : t.form.userOrganisation

            const ORGANISATION_DATA = {
                ...t.organisationForm,
                organisationName: orgName,
                organisationManagers: [t.form.entityId],
                // Ensure organisationDefaultZones is stringified before sending
                organisationDefaultZones: JSON.stringify(t.organisationForm.organisationDefaultZones),
                organisationStatus: 'Active',
                isMedia: true,
                createdDateTime: Date.now(),
                createdUserId: t.form.entityId,
                createdUserName: t.form.userName,
                organisationParkingAllocatedSpaces: 0,
                organisationParkingAllocatedCarPark: ''
            }

            const RESPONSE = await t.MIX_redis_create('organisation', ORGANISATION_DATA)

            // Handle any errors
            if (RESPONSE.hasErrors) {
                console.error('Error creating Organisation: ', RESPONSE.error)
                t.$sharedState.errorMessage = 'There was a problem creating this Organisation, please try again.'
                return
            }

            // Update the user with the new organisation ID
            t.form.userOrganisation = [RESPONSE.data.entityId]
        },

        /**
         * Emitted Image Upload
         *
         * When an image is uploaded, break apart the downloadURL and save what's required.
         * Then, update the form with the image ID.
         *
         * @param payload - The image data and download URL
         */
        async emittedImageUpload(payload) {
            const t = this

            // Set the temp profile picture to render in the UI
            t.tempProfilePicture = payload.downloadURL

            const { FOLDER_NAME, IMAGE_NAME, TOKEN } = t.MIX_extractImageDataFromUrl(payload.downloadURL)

            // Save the image data to the DB (Files collection), and add the returned image ID to the form
            t.form.userProfilePicture = await t.saveImageData(t.form.entityId, FOLDER_NAME, IMAGE_NAME, payload.image.size, TOKEN, payload.image.type)
        },

        getPossibleOrganisationMatches() {
            const t = this
            const ORGANISATIONS_DATA = t.$props.organisationsData
            const USER_ORGANISATION = Array.isArray(t.form.userOrganisation) ? t.form.userOrganisation[0] : t.form.userOrganisation

            let exactMatches = []
            let partialMatches = []

            if (!USER_ORGANISATION) return { exactMatches, partialMatches }

            // Find exact matches
            exactMatches = ORGANISATIONS_DATA.filter((org) => org.organisationName?.toUpperCase() === USER_ORGANISATION.toUpperCase())

            // Split USER_ORGANISATION into words for partial matching
            const userOrgWords = USER_ORGANISATION.toUpperCase().split(' ')

            // Find partial matches by checking if any word in USER_ORGANISATION appears in org.organisationName
            partialMatches = ORGANISATIONS_DATA.filter((org) => {
                if (!org.organisationName) return false
                const orgNameWords = org.organisationName.toUpperCase().split(' ')
                return userOrgWords.some((word) => orgNameWords.includes(word))
            }).filter((org) => !exactMatches.includes(org)) // Exclude exact matches from partial matches

            return { exactMatches, partialMatches }
        },

        /**
         * Handle Save Item
         *
         * Handle whether to create or update the item to the DB, after it has passed validation.
         */
        async handleSaveItem() {
            const t = this

            if (!t.validateForm()) return

            t.form.userLevel = `${t.form.userType}-${t.form.userRole}`

            // Handle organization data
            if (t.displayOrganisation?.entityId) {
                t.form.userOrganisation = [t.displayOrganisation.entityId]
            } else if (!Array.isArray(t.form.userOrganisation)) {
                t.form.userOrganisation = t.form.userOrganisation ? [t.form.userOrganisation] : []
            }

            t.form.userName = t.MIX_formatCapitaliseFirstLetters(t.form.userName)
            t.form.userPosition = t.MIX_formatCapitaliseFirstLetters(t.form.userPosition)
            t.form.userInternalIdNumber = t.form.userInternalIdNumber ? t.MIX_formatUserInternalIdNumber(t.form.userInternalIdNumber) : ''

            // Create Organisation - if the user is approved and doesn't have an organisation
            if (t.form.userStatus === 'Approved' && !t.displayOrganisation?.entityId) {
                await t.createOrganisation()
            }

            if (t.form.userStatus === 'Rejected') {
                await t.completelyDestroyUser()
                return
            }

            if (!t.form.entityId) {
                await t.createItem()
            } else {
                await t.updateItem()
            }
        },

        /**
         * Save Image Data
         *
         * Save the image data to the DB (Files collection).
         *
         * @param fileDocLink {string} - The file's document link
         * @param fileFolder {string} - The storage folder
         * @param fileName {string} - The file name
         * @param fileSize {number} - The file size
         * @param fileToken {string} - The file token
         * @param fileType {string} - The file type
         * @returns {Promise<*>} - The image ID
         */
        async saveImageData(fileDocLink, fileFolder, fileName, fileSize, fileToken, fileType) {
            const t = this

            const IMAGE_DATA = {
                fileDocLink,
                fileFolder,
                fileName,
                fileSize,
                fileToken,
                fileType,
                createdDateTime: 0,
                createdUserId: '',
                createdUserName: '',
                modifiedDateTime: 0,
                modifiedUserId: '',
                modifiedUserName: '',
                isDeleted: false,
                deletedDateTime: 0,
                deletedUserId: '',
                deletedUserName: ''
            }

            const RESPONSE = await t.MIX_redis_create('file', IMAGE_DATA)

            // Handle any errors
            if (RESPONSE.hasErrors) {
                console.error('Error saving File Data to DB:', RESPONSE.errors)
                t.$sharedState.errorMessage = 'There was a problem uploading your file, please try again.'
                return
            }

            return RESPONSE.data?.entityId
        },

        /**
         * Update Item
         *
         * Update the form and save to the DB.
         */
        async updateItem() {
            const t = this

            // Add the current user's level to the form data
            const updateData = {
                ...t.form,
                modifiedUserLevel: t.MIX_getCurrentUser().userLevel
            }

            const RESPONSE = await t.MIX_redis_update('user', t.form.entityId, updateData)

            // Handle any errors
            if (RESPONSE.hasErrors) {
                console.error('Error updating User: ', RESPONSE.error)
                t.$sharedState.errorMessage = 'There was a problem updating, please try again.'
                return
            }

            t.$sharedState.successMessage = 'Updated User'
            t.$emit('emitReloadPage')
        },

        /**
         * Validate Form
         *
         * Validate the form as required.
         *
         * @returns {boolean} if the form has passed validation, or not
         */
        validateForm() {
            const t = this

            t.clearErrors()

            // Name
            const USER_NAME = t.form.userName
            if (!USER_NAME) {
                t.errors.userName = true
                t.errors.userNameErrorMessage = 'Name required'
            }

            // Position
            const USER_POSITION = t.form.userPosition
            if (t.form.userType === 'Staff') {
                if (!USER_POSITION) {
                    t.errors.userPosition = true
                    t.errors.userPositionErrorMessage = 'Position required'
                }
            }

            // Email
            const USER_EMAIL = t.form.userEmail
            if (!USER_EMAIL) {
                t.errors.userEmail = true
                t.errors.userEmailErrorMessage = 'Email required'
            }
            // Must be a (simple) valid email address
            else if (!t.MIX_isEmailValid(USER_EMAIL)) {
                t.errors.userEmail = true
                t.errors.userEmailErrorMessage = 'Email not valid'
            }

            // Telephone
            const USER_TELEPHONE_NUMBER = t.form.userTelephone
            if (!USER_TELEPHONE_NUMBER) {
                t.errors.userTelephone = true
                t.errors.userTelephoneErrorMessage = 'Telephone Number is required'
            } else {
                const VALIDATED_NUMBER = t.MIX_isTelephoneNumberValid(USER_TELEPHONE_NUMBER)
                if (!VALIDATED_NUMBER) {
                    t.errors.userTelephone = true
                    t.errors.userTelephoneErrorMessage = 'Invalid Telephone Number'
                } else {
                    t.form.userTelephone = VALIDATED_NUMBER
                }
            }

            // User Pay Grade
            if (t.form.userType === 'Staff') {
                if (!t.form.userPayGrade && t.form.userType !== 'Organisation') {
                    t.errors.userPayGrade = true
                    t.errors.userPayGradeErrorMessage = 'Pay Grade required'
                }
            }

            // Outlet/Publication
            if (t.form.userType === 'Organisation') {
                if (!t.form.userOutletPublication) {
                    t.errors.userOutletPublication = true
                    t.errors.userOutletPublicationErrorMessage = 'Outlet/Publication required'
                }
            }

            // Press Type
            if (t.form.userType === 'Organisation') {
                if (!t.form.userPressType) {
                    t.errors.userPressType = true
                    t.errors.userPressTypeErrorMessage = 'Press Type required'
                }
            }

            // User Type
            if (!t.form.userType) {
                t.errors.userType = true
                t.errors.userTypeErrorMessage = 'User Type required'
            }

            // User Role
            if (!t.form.userRole) {
                t.errors.userRole = true
                t.errors.userRoleErrorMessage = 'User Role required'
            }

            // User Status
            if (!t.form.userStatus) {
                t.errors.userStatus = true
                t.errors.userStatusErrorMessage = 'User Status required'
            }

            return !Object.values(t.errors).includes(true)
        }
    }
}
</script>

<style scoped></style>
